import {SEQUENCE_USED_SOUND} from './LinkTypes.js';
import ipfs from 'decentralized/Ipfs.js';
import Sample from 'repos/Sample.js';
import ethereum from 'decentralized/ethereum.js';
import {getSampleIdsFromSequence} from 'utils/getSamplesFromSequence.js';

export async function getLinks(linkType, fromData) {
    switch(linkType) {
    case SEQUENCE_USED_SOUND:
        let sampleIds = await getSamplesFromSequence(fromData);
        return sampleIds.map(id => ({
            linkType: linkType,
            fromData: fromData,
            toData: id
        }));
    default:
        return await ethereum.xanadu.getLinks(
            linkType, fromData);
    }
}

export async function getItemFromLink(linkType, fromData, toData) {
    switch(linkType) {
    case SEQUENCE_USED_SOUND:
        let item = new Sample(toData);
        item.fromData = fromData;
        await item.fetchMetadata();
        return item;
    }
}

async function getSamplesFromSequence(id) {
    let json = await ipfs.getJson(id);
    return getSampleIdsFromSequence(json);
}
